<template>
  <div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-date-picker
          v-model="formData.start_time"
          type="datetime"
          placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="formData.end_time"
          type="datetime"
          placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="pull-right" type="primary" @click="handleExport"
          >导出主播推广费</el-button
        >
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_id" placeholder="用户ID"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_name" placeholder="用户名称"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_tag" placeholder="用户标签"></el-input>
      </el-col>

      <el-col style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.start_time"
          type="datetime"
          placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.end_time"
          type="datetime"
          placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 80px; margin-right: 20px">
        <el-button @click="handleSearch" type="primary" icon="el-icon-search"
          >搜索</el-button
        >
      </el-col>
      <el-col style="width: 80px; margin-right: 20px">
        <el-button @click="handlePromoteExport" type="primary">导出推广表</el-button>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <span>已结金额：{{ settled_amount }}</span>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <span>待处理金额：{{ wait_amount }}</span>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="用户ID">
        <template slot-scope="scope">
          <!-- <span @click="$router.push(`/user/${scope.row.user_id}`)">{{ scope.row.user_id }}</span> -->
          <span @click="pathToUser(scope.row.user_id)">{{
            scope.row.user_id
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="account" label="用户账号">
        <template slot-scope="{ row }">
          <!-- <div @click="$router.push(`/user/${row.user_id}`)"> -->
          <div @click="pathToUser(row.user_id)">
            <el-tag type="info" v-if="row.user.phone">{{
              row.user.phone
            }}</el-tag>
            <el-tag type="info" v-if="row.user.email">{{
              row.user.email
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user.user_tag" label="用户标签"></el-table-column>
      <el-table-column prop="anchor_id" label="主播ID"></el-table-column>
      <el-table-column prop="account" label="主播账号">
        <template slot-scope="{ row }">
          <span>{{ row.anchor.account }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="提取金额"></el-table-column>
      <el-table-column prop="status" label="处理状态">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.status === 1">待处理</el-tag>
          <el-tag type="success" v-if="row.status === 2">处理通过</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="new_user_count" label="新用户人数"></el-table-column>
      <el-table-column prop="old_user_count" label="老用户人数"></el-table-column>
      <el-table-column prop="new_user_amount" label="新用户渠道费"></el-table-column>
      <el-table-column prop="old_user_amount" label="老用户渠道费"></el-table-column> -->
      <el-table-column prop="created_at" label="申请时间"></el-table-column>
      <el-table-column prop="updated_at" label="处理时间"></el-table-column>
      <el-table-column prop="updated_at" label="身份信息" width="200">
        <template slot-scope="{ row }">
          <div v-if="row.anchor.card_front || row.anchor.card_side">
            <el-image
              style="width: 60px; height: 50px; margin-right: 10px"
              fit="cover"
              :src="row.anchor.card_front"
              :preview-src-list="srcList"
            ></el-image>
            <el-image
              style="width: 60px; height: 50px"
              fit="cover"
              :src="row.anchor.card_side"
              :preview-src-list="srcList"
            ></el-image>
          </div>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="{ row }">
          <el-button
            type="info"
            size="small"
            @click="viewInfo(row.anchor)"
            style="margin-bottom: 5px"
            >查看信息</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="row.status === 1"
            @click="handleChange(row)"
            >处理通过</el-button
          >
          <el-button type="danger" size="small" @click="handlDelete(row)"
            >清除身份</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
    <el-dialog title="账号信息" :visible.sync="dialogVisible" width="30%">
      <p>
        账号类型:
        <el-tag type="info" v-if="dialogData.payment.payment === 'wecaht'"
          >微信</el-tag
        >
        <el-tag type="info" v-if="dialogData.payment.payment === 'alipay'"
          >支付宝</el-tag
        >
      </p>
      <p>姓名: {{ dialogData.payment.name }}</p>
      <p>账号: {{ dialogData.payment.account }}</p>
      <p>
        收款码: <img :src="dialogData.payment.image" style="height: 300px" />
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http, { api, getData, postData, patchData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      formData: {
        start_time: '',
        end_time: '',
      },
      params: {
        page: 1,
        user_id: '',
        user_name: '',
        start_time: '',
        end_time: '',
        user_tag: ''
      },
      srcList: [],//大图预览图片列表
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1,
      dialogVisible: false,
      dialogData: {
        payment: {
          payment: '',
          name: '',
          account: '',
          image: ''
        }
      },
      settled_amount: 0,
      wait_amount: 0,
    }
  },
  methods: {
    getTableData() {
      this.loading = true
      getData('settlements', {
        ...this.params
      })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
          this.settled_amount = res.settled_amount
          this.wait_amount = res.wait_amount
          this.getPreviewImgs(res.data)//加入预览图片
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPreviewImgs(data) {
      //将获取到的列表的图片地址加入大图预览数组中
      if (data && data.length) {
        let arr = []
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].anchor.card_front)
          arr.push(data[i].anchor.card_side)
        }
        this.srcList = arr
      }
    },
    handlePageChange(page) {
      this.params.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    handlDelete(rowInfo) {
      // 清除个人信息
      this.$confirm('确定要清除身份信息吗？', {
        type: 'warning'
      }).then(res => {
        patchData(`anchor_card/${rowInfo.anchor.id}`).then(res => {
          this.$message.success('清除成功')
          this.getTableData()
        })
      }).catch(() => {
      })
    },
    handleChange(row) {
      this.$alert('是否通过申请', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            postData(`settlements/${row.id}`, { status: 2 })
              .then(res => {
                this.page = 1
                this.getTableData()
              }).finally(() => {
              })
          }
        }
      })
    },
    viewInfo(row) {
      this.dialogVisible = true
      this.dialogData = row
    },
    pathToUser(id) {
      let routeData = this.$router.resolve({ path: `/user/${id}` })
      window.open(routeData.href, '_blank')
    },
    handleExport() {
      if (!this.formData.start_time) {
        this.$message.error("开始时间必须填写")
        return
      }
      let params = this.formData
      http
        .post(
          api + 'anchor_spread_amount_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '主播推广费.xlsx'
          })
        }).finally(() => {
        })
    },
    handlePromoteExport() {
      let params = this.params
      http
        .post(
          api + 'settlement_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '推广表.xlsx'
          })
        }).finally(() => {
        })
    },
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
